import { OptionElementType } from '../reusable-components/GenericSearchableSelect';
import { postSearchCompany } from '../services/company-api';
import { CompanySearchResult } from '../models/company/CompanySearchResult';

export const useGetAllOptions = (token: string) => {
  const fileTypeOptions: OptionElementType[] = [
    { value: 'csv', title: 'CSV', description: 'Comma Separated Values' },
    { value: 'json', title: 'JSON', description: 'JavaScript Object Notation' },
    { value: 'xml', title: 'XML', description: 'Extensible Markup Language' },
    { value: 'pdf', title: 'PDF', description: 'Portable Document Format' },
    { value: 'xls', title: 'XLS', description: 'Microsoft Excel Spreadsheet' },
  ];

  const invoiceTypeOptions: OptionElementType[] = [
    {
      value: 'DVODA',
      title: 'Vodafone',
      description: 'Vodafone Germany Invoice',
    },
    {
      value: 'DVODM',
      title: 'Vodafone Mini',
      description: 'Vodafone Germany Mini Invoice',
    },
    {
      value: 'DVODC',
      title: 'Vodafone Corporate BOP',
      description: 'Vodafone Germany Corporate Invoice (BOP)',
    },
    {
      value: 'DVOCR',
      title: 'Vodafone Corporate RA',
      description: 'Vodafone Germany Corporate Invoice (RA)',
    },
    {
      value: 'DVODE',
      title: 'Vodafone Enterprise',
      description: 'Vodafone Germany Enterprise Invoice',
    },
    {
      value: 'DVODP',
      title: 'Vodafone Cost Position',
      description: 'Vodafone Germany Corporate Cost Position',
    },
    { value: 'GENER', title: 'Generic', description: 'Generic Invoice Type' },
    { value: 'EPLUS', title: 'Eplus', description: 'EPlus Invoice' },
    {
      value: 'EPLUC',
      title: 'Eplus Corporate',
      description: 'EPlus Corporate Invoice',
    },
    { value: 'EPLUA', title: 'Eplus ASC', description: 'EPlus ASC Invoice' },
    { value: 'BASE', title: 'Base', description: 'Base Invoice' },
    { value: 'SIMYO', title: 'Simyo', description: 'Simyo Invoice' },
    { value: 'TALKL', title: 'Talkline', description: 'Talkline Invoice' },
    { value: 'DEBIT', title: 'Debitel', description: 'Debitel Invoice' },
    {
      value: 'DEBIC',
      title: 'Debitel Corporate',
      description: 'Debitel Corporate Invoice',
    },
    {
      value: 'DTMOB',
      title: 'T-Mobile',
      description: 'T-Mobile Germany Invoice',
    },
    {
      value: 'DTMED',
      title: 'T-Mobile EDI',
      description: 'T-Mobile Germany EDIFACT Invoice',
    },
    {
      value: 'DTMC',
      title: 'T-Mobile Corporate',
      description: 'T-Mobile Germany Corporate Invoice',
    },
    {
      value: 'DTMBA',
      title: 'T-Mobile Business Analyzer',
      description: 'T-Mobile Germany Business Analyzer Invoice',
    },
    {
      value: 'EWEMP',
      title: 'EWE Cost Position',
      description: 'EWE Tel Cost Position Invoice',
    },
    { value: 'CONGS', title: 'Congstar', description: 'Congstar' },
    { value: 'DMC', title: 'Mobilcom', description: 'Mobilcom Invoice' },
    { value: 'DE-O2', title: 'O2', description: 'O2 Germany Invoice' },
  ];

  const networkProviderOptions: OptionElementType[] = [
    { value: 'DRSRV', title: 'Directory Service Provider', description: '' },
    { value: 'D-VOD', title: 'Vodafone Deutschland', description: '' },
    { value: 'D-TMO', title: 'T Mobile Deutschland', description: '' },
    { value: 'D-EPL', title: 'E-Plus', description: '' },
    { value: 'D-O2', title: 'O2 Deutschland', description: '' },
    { value: 'D-FIXEDNET', title: 'German FixedNet', description: '' },
    { value: 'D-FRE', title: 'German Toll Free Network', description: '' },
    { value: 'D-SKYP', title: 'eSkyper Pager Network', description: '' },
    { value: 'D-CIT', title: 'Cityruf', description: '' },
    { value: 'D-SPE', title: 'German Special Services', description: '' },
    { value: 'UKTMO', title: 'T Mobile UK', description: '' },
    { value: 'UKVOD', title: 'Vodafone UK', description: '' },
    { value: 'UKORA', title: 'Orange UK', description: '' },
    { value: 'UK02', title: 'O2 UK', description: '' },
    { value: 'UK3', title: 'Three UK', description: '' },
    { value: 'ROAM', title: 'Roaming Service Provider', description: '' },
  ];

  const serviceProviderOptions: OptionElementType[] = [
    { value: 'TMOB', title: 'T-Mobile', description: '' },
    { value: 'VODA', title: 'Vodafone', description: '' },
    { value: 'E+', title: 'E-Plus', description: '' },
    { value: 'BASE', title: 'BASE', description: '' },
    { value: 'SIMYO', title: 'Simyo', description: '' },
    { value: 'O2', title: 'O2 Germany', description: '' },
    { value: 'MC', title: 'Mobilcom', description: '' },
    { value: 'MCD', title: 'Mobilcom debitel', description: '' },
    { value: 'FN', title: 'Freenet', description: '' },
    { value: 'TALKL', title: 'Talkline', description: '' },
    { value: 'DEBIT', title: 'Debitel', description: '' },
    { value: 'CONGS', title: 'Congstar', description: '' },
    { value: 'FONIC', title: 'Fonic', description: '' },
    { value: 'TCHIB', title: 'Tchibo Mobil', description: '' },
  ];

  /* These are the tariff flags that we need in this page (121 flag values):
RX968, 133334T, 133334D, TMR03, TCAL, TCAS, TCOM, TCCO, TC50, TDAT, SUST, SUSD, VPLU, VPRO, VCON, VRED, Stahlcranes, 133333T, Leitz1, Leitz2, Leitz3, Leitz4, Leitz5, Test1, Test2, Test3, CHT, CHTF, CHTD, ARaymondT, ARaymondD, SewerinT1, SewerinT2a, SewerinT2b, SewerinT3, SewerinT4, SewerinD, Selex, VWHITE, VDFTritonT, VDFTritonD, TTritonT1, TTritonT2, TTritonD, SewerinTest, 457097T, 457097D, TSUST, TSUSD, Leitz6, Nordic1, Nordic2, Nordic3, Nordic4, Nordic5, Nordic6, Nordic7, Nordic8, Nordic9, Nordic10, RV211, TM, TM211, CHTNT, CHTNTD, CHTNTXS, CHTND, 133335T, 133335TA, AKVRED, Schmersal1, Schmersal2, SchmersalD, SchwenningF, SchwenningC, VREDP, VREDPXS, DHPLU, BeroaV, DHVREDPXS, DHVREDP, DHVREDDAT, 303140RB, 303140RP, 303140A, 303140P, 303140W, 303140RD, 303140RS, ODEGCM, ODEGXS, ODEGS, TP171, TP172, TP173, TP174, TP175, TP17VDF1, TP17VDF2, TP17VDF3, TP17VDF4, Triton18B, Triton18SPWF, VPRIME, TMNB, TMNBInstart, InstartRP, InstartRB, InstartSM, InstartPRIME, VDFSP, AO2, TTritonM, TTritonD2, TTritonAllnet, TTritonT3, O2G50S, O2G50, O2G50P, VerbandVDFSP, VerbandVPRIME,
  */
  const tariffOptions: OptionElementType[] = [
    { value: 'RX968', title: 'RX968', description: '' },
    { value: '133334T', title: '133334T', description: '' },
    { value: '133334D', title: '133334D', description: '' },
    { value: 'TMR03', title: 'TMR03', description: '' },
    { value: 'TCAL', title: 'TCAL', description: '' },
    { value: 'TCAS', title: 'TCAS', description: '' },
    { value: 'TCOM', title: 'TCOM', description: '' },
    { value: 'TCCO', title: 'TCCO', description: '' },
    { value: 'TC50', title: 'TC50', description: '' },
    { value: 'TDAT', title: 'TDAT', description: '' },
    { value: 'SUST', title: 'SUST', description: '' },
    { value: 'SUSD', title: 'SUSD', description: '' },
    { value: 'VPLU', title: 'VPLU', description: '' },
    { value: 'VPRO', title: 'VPRO', description: '' },
    { value: 'VCON', title: 'VCON', description: '' },
    { value: 'VRED', title: 'VRED', description: '' },
    { value: 'Stahlcranes', title: 'Stahlcranes', description: '' },
    { value: '133333T', title: '133333T', description: '' },
    { value: 'Leitz1', title: 'Leitz1', description: '' },
    { value: 'Leitz2', title: 'Leitz2', description: '' },
    { value: 'Leitz3', title: 'Leitz3', description: '' },
    { value: 'Leitz4', title: 'Leitz4', description: '' },
    { value: 'Leitz5', title: 'Leitz5', description: '' },
    { value: 'Test1', title: 'Test1', description: '' },
    { value: 'Test2', title: 'Test2', description: '' },
    { value: 'Test3', title: 'Test3', description: '' },
    { value: 'CHT', title: 'CHT', description: '' },
    { value: 'CHTF', title: 'CHTF', description: '' },
    { value: 'CHTD', title: 'CHTD', description: '' },
    { value: 'ARaymondT', title: 'ARaymondT', description: '' },
    { value: 'ARaymondD', title: 'ARaymondD', description: '' },
    { value: 'SewerinT1', title: 'SewerinT1', description: '' },
    { value: 'SewerinT2a', title: 'SewerinT2a', description: '' },
    { value: 'SewerinT2b', title: 'SewerinT2b', description: '' },
    { value: 'SewerinT3', title: 'SewerinT3', description: '' },
    { value: 'SewerinT4', title: 'SewerinT4', description: '' },
    { value: 'SewerinD', title: 'SewerinD', description: '' },
    { value: 'Selex', title: 'Selex', description: '' },
    { value: 'VWHITE', title: 'VWHITE', description: '' },
    { value: 'VDFTritonT', title: 'VDFTritonT', description: '' },
    { value: 'VDFTritonD', title: 'VDFTritonD', description: '' },
    { value: 'TTritonT1', title: 'TTritonT1', description: '' },
    { value: 'TTritonT2', title: 'TTritonT2', description: '' },
    { value: 'TTritonD', title: 'TTritonD', description: '' },
    { value: 'SewerinTest', title: 'SewerinTest', description: '' },
    { value: '457097T', title: '457097T', description: '' },
    { value: '457097D', title: '457097D', description: '' },
    { value: 'TSUST', title: 'TSUST', description: '' },
    { value: 'TSUSD', title: 'TSUSD', description: '' },
    { value: 'Leitz6', title: 'Leitz6', description: '' },
    { value: 'Nordic1', title: 'Nordic1', description: '' },
    { value: 'Nordic2', title: 'Nordic2', description: '' },
    { value: 'Nordic3', title: 'Nordic3', description: '' },
    { value: 'Nordic4', title: 'Nordic4', description: '' },
    { value: 'Nordic5', title: 'Nordic5', description: '' },
    { value: 'Nordic6', title: 'Nordic6', description: '' },
    { value: 'Nordic7', title: 'Nordic7', description: '' },
    { value: 'Nordic8', title: 'Nordic8', description: '' },
    { value: 'Nordic9', title: 'Nordic9', description: '' },
    { value: 'Nordic10', title: 'Nordic10', description: '' },
    { value: 'RV211', title: 'RV211', description: '' },
    { value: 'TM', title: 'TM', description: '' },
    { value: 'TM211', title: 'TM211', description: '' },
    { value: 'CHTNT', title: 'CHTNT', description: '' },
    { value: 'CHTNTD', title: 'CHTNTD', description: '' },
    { value: 'CHTNTXS', title: 'CHTNTXS', description: '' },
    { value: 'CHTND', title: 'CHTND', description: '' },
    { value: '133335T', title: '133335T', description: '' },
    { value: '133335TA', title: '133335TA', description: '' },
    { value: 'AKVRED', title: 'AKVRED', description: '' },
    { value: 'Schmersal1', title: 'Schmersal1', description: '' },
    { value: 'Schmersal2', title: 'Schmersal2', description: '' },
    { value: 'SchmersalD', title: 'SchmersalD', description: '' },
    { value: 'SchwenningF', title: 'SchwenningF', description: '' },
    { value: 'SchwenningC', title: 'SchwenningC', description: '' },
    { value: 'VREDP', title: 'VREDP', description: '' },
    { value: 'VREDPXS', title: 'VREDPXS', description: '' },
    { value: 'DHPLU', title: 'DHPLU', description: '' },
    { value: 'BeroaV', title: 'BeroaV', description: '' },
    { value: 'DHVREDPXS', title: 'DHVREDPXS', description: '' },
    { value: 'DHVREDP', title: 'DHVREDP', description: '' },
    { value: 'DHVREDDAT', title: 'DHVREDDAT', description: '' },
    { value: '303140RB', title: '303140RB', description: '' },
    { value: '303140RP', title: '303140RP', description: '' },
    { value: '303140A', title: '303140A', description: '' },
    { value: '303140P', title: '303140P', description: '' },
    { value: '303140W', title: '303140W', description: '' },
    { value: '303140RD', title: '303140RD', description: '' },
    { value: '303140RS', title: '303140RS', description: '' },
    { value: 'ODEGCM', title: 'ODEGCM', description: '' },
    { value: 'ODEGXS', title: 'ODEGXS', description: '' },
    { value: 'ODEGS', title: 'ODEGS', description: '' },
    { value: 'TP171', title: 'TP171', description: '' },
    { value: 'TP172', title: 'TP172', description: '' },
    { value: 'TP173', title: 'TP173', description: '' },
    { value: 'TP174', title: 'TP174', description: '' },
    { value: 'TP175', title: 'TP175', description: '' },
    { value: 'TP17VDF1', title: 'TP17VDF1', description: '' },
    { value: 'TP17VDF2', title: 'TP17VDF2', description: '' },
    { value: 'TP17VDF3', title: 'TP17VDF3', description: '' },
    { value: 'TP17VDF4', title: 'TP17VDF4', description: '' },
    { value: 'Triton18B', title: 'Triton18B', description: '' },
    { value: 'Triton18SPWF', title: 'Triton18SPWF', description: '' },
    { value: 'VPRIME', title: 'VPRIME', description: '' },
    { value: 'TMNB', title: 'TMNB', description: '' },
    { value: 'TMNBInstart', title: 'TMNBInstart', description: '' },
    { value: 'InstartRP', title: 'InstartRP', description: '' },
    { value: 'InstartRB', title: 'InstartRB', description: '' },
    { value: 'InstartSM', title: 'InstartSM', description: '' },
    { value: 'InstartPRIME', title: 'InstartPRIME', description: '' },
    { value: 'VerbandVPRIME', title: 'VerbandVPRIME', description: '' },
    { value: 'VerbandVDFSP', title: 'VerbandVDFSP', description: '' },
    { value: 'VDFSP', title: 'VDFSP', description: '' },
    { value: 'AO2', title: 'AO2', description: '' },
    { value: 'TTritonM', title: 'TTritonM', description: '' },
    { value: 'TTritonD2', title: 'TTritonD2', description: '' },
    { value: 'TTritonAllnet', title: 'TTritonAllnet', description: '' },
    { value: 'TTritonT3', title: 'TTritonT3', description: '' },
    { value: 'O2G50S', title: 'O2G50S', description: '' },
    { value: 'O2G50', title: 'O2G50', description: '' },
    { value: 'O2G50P', title: 'O2G50P', description: '' },
  ];

  const getAllCompaniesOptions = async () => {
    const companies: CompanySearchResult[] = await postSearchCompany({
      token,
      companyId: '',
      name: '',
      limit: 100000, // upper limit: 100K (should not limit the companies)
    });

    return companies
      .filter((c) => c.companyId !== 0)
      .sort((a, b) => {
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
      })
      .map((c: CompanySearchResult) => ({
        value: c.companyId.toString(),
        title: c.name,
        description: c.companyId.toString(),
      })) as OptionElementType[];
  };
  return {
    fileTypeOptions,
    invoiceTypeOptions,
    serviceProviderOptions,
    networkProviderOptions,
    tariffOptions,
    getAllCompaniesOptions,
  };
};
